import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {InviteAFriendComponent} from '../../modals/invite-a-friend/invite-a-friend.component';
import {EventsManager} from '../../../events/events.manager';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.scss'],
  standalone: false
})

export class SubheaderComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _eventsManager: EventsManager = inject(EventsManager);
  private _modalService: NgbModal = inject(NgbModal);

  public office: any = {};
  public environment: any = environment;

  public ngOnInit(): void {
    this.office = this._eventsManager.getOfficeInfo();
    this._eventsManager.officeUpdate
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.office = result;
      });
  }

  public inviteAFriend() {
    const modalRef: NgbModalRef = this._modalService.open(InviteAFriendComponent);
    modalRef.result.then(() => {
      this._closeModal();
    });
  }

  private _closeModal() {
    this._modalService.dismissAll();
  }

  public get logoUrl(): string {
    return getComputedStyle(document.documentElement).getPropertyValue('--organization-logo').trim();
  }
}
